import {createStore, applyMiddleware} from 'redux'
import rootReducer from '../reducers'
import thunk from 'redux-thunk'
import {composeWithDevTools} from 'redux-devtools-extension'
import storage from 'redux-persist/lib/storage'
import {persistStore, persistReducer, createMigrate} from 'redux-persist'
import {
  VERSION_CACHE_CATALOGOS,
  envolverConPurgaDeCatalogos,
  migracionesPersistencia,
  vigilarVersionNormativaCatalogos,
} from './catalogos.persistencia'
import {SLICES_PERSISTIDOS} from './persistencia.whitelist'

const persistConfig = {
  key: 'root',
  debug: true,
  storage,
  version: VERSION_CACHE_CATALOGOS,
  migrate: createMigrate(migracionesPersistencia, {debug: false}),
  whitelist: SLICES_PERSISTIDOS,
}

const persistedReducer = persistReducer(persistConfig, envolverConPurgaDeCatalogos(rootReducer))

export const store = createStore(persistedReducer, {}, composeWithDevTools(applyMiddleware(thunk)))
export const persistor = persistStore(store)

vigilarVersionNormativaCatalogos(store)
